module.exports = "/_next/static/images/jo-17530dec71e4c015cfae93d2e8622b36.svg";